import React from 'react';
import '../../../assests/css/students/Missionsection.css';

const Missionsection = () => {
  const missionPoints = [
    'To provide accessible, affordable, and quality education at the graduate level',
    'Fostering academic excellence, critical thinking, and ethical values',
    'Prepare students for higher studies, professional careers, and responsible citizenship'
  ];

  return (
    <section className="mission-section">
      <div className="mission-container">
        <div className="mission-image-side">
          <div className="mission-image-wrapper">
            <div className="mission-circle-bg"></div>
            <div className="mission-image-content">
              <div className="mission-placeholder-image">
                <span className="mission-emoji">👨‍🏫</span>
              </div>
            </div>
            <div className="mission-orange-dot"></div>
            <div className="mission-small-dot"></div>
          </div>
        </div>

        <div className="mission-content-side">
          <h2 className="mission-heading">Our Mission</h2>
          <p className="mission-description">
            To provide accessible, affordable, and quality education at the graduate level,
            fostering academic excellence, critical thinking, and ethical values to prepare 
            students of Gujranwala and surrounding regions for higher studies, professional 
            careers, and responsible citizenship.
          </p>

          <ul className="mission-points">
            {missionPoints.map((point, index) => (
              <li key={index} className="mission-point">
                <svg className="mission-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" fill="#FF8C42" stroke="#FF8C42" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Missionsection;